
import api from "@/services/api"
import { Field } from "@/types"
import { dataTypes } from "@/types/dataType"
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import SearchDropDown from "./SearchDropDown.vue"

@Component({
	components: {
		"search-dropdown": SearchDropDown
	}
})
export default class DataObjectSearchDropdown extends Vue {
	@Prop({ type: Array, default: () => [] })
	options!: { id: string, label: string }[]

	private dataObjectOptions: { id: string, label: string }[] = this.options;
	private allDataObjectLoaded: boolean = false;

	@Watch("options")
	private onOptionsChanged (newValue: { id: string, label: string }[]) : void {
		this.dataObjectOptions = newValue
	}

	private async loadAllDataObjects (): Promise<void> {
		if (this.allDataObjectLoaded) {
			return
		}

		// Prevent api.fields() being called each time
		this.allDataObjectLoaded = true

		// Get all fields
		const fields: Field[] = await api.fields()

		// Exclude any fields that already exist (passed through as props)
		const idsToExclude = this.dataObjectOptions.map(d => d.id)
		const allDataObjects = fields.filter(field => field.dataType && field.dataType === dataTypes.DataObject && field.id && !idsToExclude.includes(field.id))
			.map(field => {
				return {
					id: `fields.${field.id}`,
					label: field.title
				}
			}) as { id: string, label: string }[]

		this.dataObjectOptions = this.dataObjectOptions.concat(allDataObjects)
	}
}
